import _ from "lodash";

export const DATA_LIMIT = 40;

export const PROMPT_FIELDS_LIST = [
    {attribute: "type", label: "Type", cssClass: 'text-center w-32'},
    {attribute: "subType", label: "Sub Type", cssClass: 'text-center w-64'},
    {attribute: "title", label: "Title"},
    {attribute: "status", label: "Status", cssClass: 'text-center w-32'},
];

export const PROMPT_STATUS_LIST = [
    {key: 'Enabled', label: 'Enabled'},
    {key: 'Disabled', label: 'Disabled'},
];

export const PROMPT_TYPE_LIST = [
    {key: 'Blog', label: 'Blog'},
    {key: 'Product Blog', label: 'Product Blog'},
];

export const PROMPT_BLOG_SUBTYPE_LIST = [
    {key: 'Title', label: 'Title'},
    {key: 'Section', label: 'Section'},
    {key: 'Tags', label: 'Tags'},
    {key: 'Product Blog Title', label: 'Product Blog Title'},
    {key: 'Main Content', label: 'Main Content'},
    {key: 'Excerpts/Tags/Meta Description', label: 'Excerpts/Tags/Meta Description'},
    {key: 'Description/Meta Title & Description', label: 'Description/Meta Title & Description'},
];

export const PROMPT_BLOG_SUBTYPE_LIST_MAP = {
    'Blog': [
        {key: 'Title', label: 'Title'},
        {key: 'Section', label: 'Section'},
        {key: 'Tags', label: 'Tags'},
    ],
    'Product Blog': [
        {key: 'Product Blog Title', label: 'Product Blog Title'},
        {key: 'Main Content', label: 'Main Content'},
        {key: 'Excerpts/Tags/Meta Description', label: 'Excerpts/Tags/Meta Description'},
    ]
};


export const PROMPT_INPUT_FIELDS = [
    {attribute: "title", label: "Title", type: 'text-area', readOnly: false, group: 'prompt'},
    {
        attribute: "type",
        label: "Type",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: PROMPT_TYPE_LIST,
        default: 'Blog'
    },
    {
        attribute: "subType",
        label: "Sub Type",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: PROMPT_BLOG_SUBTYPE_LIST,
        default: ''
    },
    {
        attribute: "status",
        label: "Status",
        type: 'select',
        readOnly: false,
        group: 'filter',
        options: PROMPT_STATUS_LIST,
        default: 'Enabled'
    },
];



